import { createBrowserHistory } from 'history';

export default createBrowserHistory();


// WEBPACK FOOTER //
// ./src/helpers/history.js